<h2 mat-dialog-title>{{ 'ADD_USER' | translate }}</h2>

<mat-dialog-content [formGroup]="userForm">
    <div class="col-span-12">
        <mat-label>{{ 'USER_NAME' | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="id" [multiple]="true" placeholder="Select Name">
                <mat-option *ngFor="let user of staffList" [value]="user?.id">
                    {{ user?.full_name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="userForm.get('id')?.hasError('required')">
                 {{ 'NAME_REQUIRED' | translate }}
            </mat-error>
        </mat-form-field>
    </div>
    <div class="col-span-12">
        <mat-label>{{ 'START_DATE' | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
            <input matInput [matDatepicker]="startPicker" formControlName="start_date" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="userForm.get('start_date')?.invalid"> {{ 'REQUIRED' | translate }}</mat-error>
        </mat-form-field>
    </div>
    <div class="col-span-12">
        <mat-label>{{ 'END_DATE' | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
            <input matInput [matDatepicker]="endPicker" formControlName="end_date" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            <mat-error *ngIf="userForm.get('end_date')?.invalid"> {{ 'REQUIRED' | translate }}</mat-error>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="userForm.invalid">
          {{ 'SAVE' | translate }}
    </button>
</mat-dialog-actions>